// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ed12c8a6","208":"4a3d9e32"}[chunkId] + ".chunk.js";
};